// =====================================
//
//   Footer Tab
//   Author: Gray
//   createtime: 2016 / 08 / 24
//   updatetime: 2016 / 08 / 24
//
// =====================================

window.InifECMobileApp.directive('footerTab', ['$rootScope', '$state', 'UserService', 'ShoppingCartService', 'MessageService', 'OrderService', '$timeout',
    function($rootScope, $state, UserService, ShoppingCartService, MessageService, OrderService, $timeout) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

        var isActiveHome = function() {

            switch ($scope.state) {
                case window.STATES.HOME:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveProduct = function() {

            switch ($scope.state) {
                case window.STATES.PRODUCT_LIST:
                case window.STATES.PRODUCT:
                case window.STATES.COMPLEX_PDT:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveOrder = function() {

            switch ($scope.state) {
                case window.STATES.ORDER:
                case window.STATES.ORDER_LIST:
                case window.STATES.ORDER_LIST_ALL:
                case window.STATES.ORDER_LIST_PAY:
                case window.STATES.ORDER_LIST_DISCARD:
                case window.STATES.ORDER_LIST_SUCCESS:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveCart = function() {

            switch ($scope.state) {
                case window.STATES.CART:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveOther = function() {

            switch ($scope.state) {
                case window.STATES.OTHER:
                case window.STATES.ORDER_HISTORY:
                case window.STATES.SYSTEM_MESSAGE:
                case window.STATES.ABOUT:
                case window.STATES.CONTACT:
                case window.STATES.FAQ:
                case window.STATES.FAQ_CONTENT:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveDesign = function() {

            switch($scope.state){
                case window.STATES.DESIGN_RSC:
                case window.STATES.BLOG_LIST:
                case window.STATES.BLOG_POST:
                case window.STATES.RESOURCE_LIST:
                case window.STATES.DESIGNER_LIST:
                case window.STATES.PROJECT_LIST:
                case window.STATES.PROJECT_POST:
                case window.STATES.DESIGNER:
                    return true;
                default:
                    return false;
            }
        }

        // --------------------------------
        // [private] 取得所有系統通知訊息以及最後讀取時間
        // --------------------------------
        var getAllMsgs = function() {

            if($scope.isLoadingMsg) {
                return;
            }

            var msgBadget = 0;
            $scope.isLoadingMsg = true;
            
            MessageService.getAllMsgs().then(function(result) {

                if(result && Array.isArray(result.msgs) && result.msgs.length > 0) {
                    $scope.messageList = result.msgs;

                    if(!$scope.lastopentime) {
                        $scope.lastopentime = result.lastopentime;
                    }

                    for(var i = 0; i < $scope.messageList.length; i++) {
                        
                        if($scope.messageList[i].createtime < $scope.lastopentime) {
                            break;
                        }

                        msgBadget++;
                    }

                    MessageService.setMsgBadget(msgBadget);

                    $scope.isLoadingMsg = false;
                }
            });
        }

        var getOrderPayBadget = function() {

            OrderService.getOrderPayBadget().then(function(result){
                if(!window.isNaN(result)) {
                    $scope.orderPayBadget = result;
                }
            });
        }

        var updateOrderTabTip = function() {

            MessageService.setOrderTabShowTip(false);
        }

        var isShowOrderTabTip = function() {

            if(!$scope.isLogin) {
                return false;
            } else if($scope.orderPayBadget > 0) {
                return true;
            } else if($scope.isOrderTabShowTip && $scope.msgBadget > 0) {
                return true;
            } else {
                return false;
            }
        }

        // --------------------------------
        // [private] 取得使用者資訊
        // --------------------------------
        var getUserInfo = function(skipCache) {

            UserService.getUserInfo(skipCache).then(function(result) {
                $scope.isLogin = true;
                getAllMsgs();
                getOrderPayBadget();

            }, function(error) {
                $scope.isLogin = false;
            });
        }

        var getShoppingCartItemSize = function() {

            return ShoppingCartService.getAllCartShoppingCartItemSize();
        }

    	var init = function() {

            $scope.state = $state.current.name;

            getUserInfo(true);

            $timeout(function(){
                requestAnimationFrame(function() {
                    $rootScope.$broadcast('LOAD_ALL_MODALS');
                });
            });
    	}

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $scope.state = $state.current.name;
        });

        $scope.$on('LOGIN_SUCCESS', function(event, data){
            
            $scope.state = $state.current.name;

            getUserInfo(true);
            // 登入成功後重新拉購物車資訊
            ShoppingCartService.getShoppingCart(true);
        });

        $scope.$on('LOGOUT_SUCCESS', function(event, data){

            $scope.state = $state.current.name;

            getUserInfo(true);
            ShoppingCartService.logutResetCart();
        });

        //==========================
        //  Members
        //==========================
        $scope.state;
        $scope.cms_project_url = CMS_URL + '/project';
        $scope.orderPayBadget = 0;
        $scope.isLoadingMsg = false;
        $scope.msgBadget = MessageService.msgBadget;
        $scope.isOrderTabShowTip = MessageService.isOrderTabShowTip;

        //==========================
        //  Methods
        //==========================
        $scope.isActiveHome = isActiveHome;
        $scope.isActiveProduct = isActiveProduct;
        $scope.isActiveOrder = isActiveOrder;
        $scope.isActiveCart = isActiveCart;
        $scope.isActiveOther = isActiveOther;
        $scope.isActiveDesign = isActiveDesign;
        $scope.getShoppingCartItemSize = getShoppingCartItemSize;
        $scope.updateOrderTabTip = updateOrderTabTip;
        $scope.isShowOrderTabTip = isShowOrderTabTip;

        //==========================
        //  Init
        //==========================
        init();

	}];

	_dir.restrict = 'E';
	_dir.scope = true;
	_dir.templateUrl = "mobile/partials/directives/footer_tab.html";
	_dir.controller = controller;

	return _dir;

}]);
